import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild, ViewContainerRef, ɵɵsetNgModuleScope } from '@angular/core';
import { paragraphMapper } from 'src/app/models/paragraphs.model';
interface PartialType {
  type: string;
  [key: string]: any;
}

@Component({
  selector: 'app-information-layout',
  templateUrl: './information-layout.component.html',
  styleUrls: ['./information-layout.component.scss']
})

export class InformationLayoutComponent implements OnInit {
  @Input() data: any; // This should have a property called paragraphs which is an array of paragraph data.
  @ViewChild('dynamicParagraph', { read: ViewContainerRef })
  dynamicParagraph!: ViewContainerRef;

  loading: boolean = true;
  partials: any
  links: any[] = [];

  constructor(dynamicParagraph: ViewContainerRef,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.dynamicParagraph = dynamicParagraph;
  }
  async ngOnInit() {
    this.partials = Array.isArray(this.data[this.data.type + '_partials']) ? this.data[this.data.type + '_partials'] : [];

    const viewContainerRef = this.dynamicParagraph; // Move this line outside the loop
    viewContainerRef.clear(); // Clear the view container once
    if (!this.partials?.data?.length) {
      this.links = this.partials
        .map((partial: PartialType) => {
          const title = partial[partial.type + '_title'];
          if (title) {
            //replace any spacial character or space with _
            const url = title.replace(/[^a-zA-Z0-9]/g, '_');
            return {
              title,
              url
            };
          }
          return null;
        })
        .filter((link: any) => link !== null) as { title: string; url: string }[];
    } else {
      this.links = [];
    }

    for (const paragraph of this.partials) {
      const paragraphType = paragraph.type;
      const paragraphData = paragraph;

      const module: any = await paragraphMapper(paragraphType);

      if (module && module.component) {
        ɵɵsetNgModuleScope(module, {
          declarations: [module.component],
          imports: [CommonModule],
          exports: [module.component]
        });

        const componentRef: any = viewContainerRef.createComponent(module.component);
        const article = this.renderer.createElement('article');
        const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        const titleID = paragraph[paragraphType + '_title'] ? paragraph[paragraphType + '_title'].replace(/[^a-zA-Z0-9]/g, '_') : randomId;

        this.renderer.setAttribute(article, 'id', titleID);
         this.renderer.setAttribute(article, 'class', 'it-page-section anchor-offset mt-5');

        const section = this.elementRef.nativeElement.querySelector('section');
        if (section) {
          this.renderer.appendChild(section, article);
        }

        this.renderer.appendChild(article, componentRef.location.nativeElement);

        if (paragraphData) {
          componentRef.instance.data = paragraphData;
        }

        this.loading = false;
      } else {
        console.error(`Paragraph type ${paragraphType} not found`);
      }
    }

    const section: HTMLElement | null = this.elementRef.nativeElement.querySelector('section');

    if (section) {
      const updatedDate: HTMLElement = this.renderer.createElement('article');
      this.renderer.setAttribute(updatedDate, 'id', 'ultimo-aggiornamento');
      this.renderer.setAttribute(updatedDate, 'class', 'anchor-offset mt-5 richtext-wrapper');

      const h4: HTMLElement = this.renderer.createElement('h4');
      this.renderer.setAttribute(h4, 'class', 'h6');
      this.renderer.setProperty(h4, 'innerText', 'Ultimo aggiornamento: ');

      const span: HTMLElement = this.renderer.createElement('span');
      this.renderer.setAttribute(span, 'class', 'h6 fw-normal');
      this.renderer.setProperty(span, 'innerText', this.formatData(this.data.changed));

      this.renderer.appendChild(h4, span);
      this.renderer.appendChild(updatedDate, h4);
      this.renderer.appendChild(section, updatedDate);
    }

  }
  scrollTo(id: string) {
    const element = document.querySelector('#' + id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  formatData(data: string) {
    const date = new Date(data);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return day + '/' + month + '/' + year;
  }
}


